import {
  ORGANIZATIONS_GET,
  SET_MODAL_SHOW,
  SET_MODAL_SELECTED_ORG_ID,
  SET_MODAL_SEARCH_VALUE,
} from '../constants';

const defaultState = {
  organizations: [],
  showConfirmBox: false,
  selectedOrganizationSystemId: '',
  searchValue: '',
};
export const organizationList = (state = defaultState, action) => {
  const { type, payload } = action;
  switch (type) {
    case ORGANIZATIONS_GET:
      return {
        ...state,
        organizations: payload.organizations,
      };
    case SET_MODAL_SHOW:
      return {
        ...state,
        showConfirmBox: action.payload,
      };
    case SET_MODAL_SELECTED_ORG_ID:
      return {
        ...state,
        selectedOrganizationSystemId: action.payload,
      };
    case SET_MODAL_SEARCH_VALUE:
      return {
        ...state,
        searchValue: action.payload,
      };
    default:
      return state;
  }
};
